import { PplxError } from '#pplx/frontend/common/errors.js';
export class PplxStreamError extends PplxError {
    name = 'PplxStreamError';
}
//# sourceMappingURL=errors.js.map